import { useAtomValue } from 'jotai';
import { capitalize } from 'lodash-es';
import { useCallback } from 'react';
import { ICompanyDataModel } from '../../../../../data-models/company.data-model';
import { sectorsByIdMapAtom, usersByIdMapAtom } from '../../../../../services/state/AppConfigStateJ';
import { activeCompanyListIdStateJ } from '../../../../../services/state/ListsStateJ';
import { formatDateNumeric } from '../../../../../util/formatters/DateFormatters';
import { useGetCompanyIfSet } from '../../../hooks/useGetCompanyData';
import { filteredAndSortedListsStateJ } from '../../state/FiltersStateJ';

export function useGenerateCompanyRows() {
  const activeListId = useAtomValue(activeCompanyListIdStateJ);
  const sortedItemsList = useAtomValue(filteredAndSortedListsStateJ(activeListId ?? -1));
  const usersMap = useAtomValue(usersByIdMapAtom);
  const sectorsMap = useAtomValue(sectorsByIdMapAtom);
  const getCompany = useGetCompanyIfSet();

  return useCallback(() => {
    const companiesRows = [] as Record<string, string>[];
    sortedItemsList?.forEach((item) => {
      // Get most updated company values
      const itemCompany = getCompany(item.companyId);

      const selectedItemDetailsSector = sectorsMap.get(itemCompany?.sectorId ?? -1);

      const owner = usersMap.get(itemCompany?.assignee ?? -1)?.name ?? '';
      const sector = selectedItemDetailsSector?.name ?? '';

      const { actionType, createdAt: addedDate, updatedAt: actionDate } = item;

      const { name: companyName, website } = itemCompany as ICompanyDataModel;

      companiesRows.push({
        companyName,
        website: website ?? '',
        sector,
        addedDate: formatDateNumeric(addedDate),
        action: capitalize(actionType ?? ''),
        actionDate: actionDate ? formatDateNumeric(actionDate) : '',
        owner: owner,
      });
    });

    return companiesRows;
  }, [getCompany, sortedItemsList, usersMap, sectorsMap]);
}
